export default __webpack_public_path__ + "static/media/updates-reversed.11a23411.svg";